import React from "react";
import {AppContextProvider} from "../../context/AppContext";
import CheckIn from "./CheckIn";
import App from "../../App";
import VolumeMeter from "../../helper/VolumeMeter";
import {Navigate, Route, Routes} from "react-router-dom";
import ErrorBoundary from "../general/ErrorBoundary";
import SessionFailed from "./SessionFailed";

export default () => {
  return <AppContextProvider>
    <ErrorBoundary fallback={reset => <SessionFailed onBack={reset}/>}>
      <Routes>
        <Route path="/join/:token" element={<CheckIn/>}/>
        <Route path="/meeting" element={<App/>}/>
        <Route path="*" element={<Navigate to="/meeting" replace/>}/>
      </Routes>
    </ErrorBoundary>
  </AppContextProvider>
}
